export default __webpack_public_path__ + "static/media/home1.eef81485.jpg";